import styled from 'styled-components';

import { Button } from 'basics/buttons';

import {
    cardBoxShadow,
    flexAllCenter,
    flexColumn,
    flexColumnCenter,
    respondDown,
} from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const List = styled.div`
    ${flexColumn};
    width: 60%;

    ${respondDown(Breakpoints.lg)`
        width: 100%;
    `}
`;

export const Empty = styled.div`
    position: absolute;
    left: calc(100% + 4rem);
    top: 0;
    background-color: ${COLORS.white};
    ${cardBoxShadow};
    ${flexColumnCenter};
    width: 50%;
    border-radius: 2.4rem;
    padding: 2.4rem;
    gap: 2.4rem;
    cursor: auto;

    span {
        font-size: 1.6rem;
        line-height: 2.8rem;
        color: ${COLORS.textSecondary};
    }

    ${respondDown(Breakpoints.lg)`
        display: none;
    `}
`;

export const ButtonMobile = styled(Button)`
    display: none;
    margin-bottom: 2.4rem;

    ${respondDown(Breakpoints.lg)`
        display: flex;
    `}
`;

export const IconWrap = styled.div`
    ${flexAllCenter};
    height: 6.4rem;
    width: 6.4rem;
    border-radius: 50%;
    background-color: ${COLORS.gray50};

    svg {
        height: 1.6rem;
        width: 1.6rem;
    }
`;
